import { nowIsoAndUnix } from "@@/shared/date-time/iso-and-unix";
import { storageItemImageIdZodSchema } from "@@/shared/storage-items/storage-item-images/storage-item-image-id";
import { storageItemImageReferenceZodSchema } from "@@/shared/storage-items/storage-item-images/storage-item-image-reference";
import { faPageBreak } from "@fortawesome/pro-solid-svg-icons";
import type { Except } from "type-fest";
import { z } from "zod";
import type { _PageBlockBase} from "../page-block-base";
import { pageBlockBaseZodSchema } from "../page-block-base";
import { pageBlockIdFactory } from "../page-block-id";

const spacerPageBlockZodSchema = pageBlockBaseZodSchema.merge(
    z.object({
        type: z.literal("SPACER_PAGE_BLOCK"),
        height: z.number().int().min(0).optional(),
        backgroundImage: z
            .union([
                storageItemImageReferenceZodSchema,
                storageItemImageIdZodSchema,
            ])
            .optional(),
    }),
);

type SpacerPageBlock = z.infer<typeof spacerPageBlockZodSchema> &
    _PageBlockBase;

const spacerPageBlockIcon = faPageBreak;
type SpacerPageBlockParams = Except<
    SpacerPageBlock,
    "_id" | "type" | "_type" | "_createdAt"
>;
const spacerPageBlockFactory = (
    params: SpacerPageBlockParams,
): SpacerPageBlock => {
    return {
        ...params,
        _id: pageBlockIdFactory(),
        _type: "PAGE_BLOCK",
        _createdAt: nowIsoAndUnix(),
        type: "SPACER_PAGE_BLOCK",
    };
};

const SpacerPageBlock_Edit = () => {
    return null;
};

const spacerPageBlockType = "SPACER_PAGE_BLOCK";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isSpacerPageBlock = (input: any): input is SpacerPageBlock => {
    return input._type === "PAGE_BLOCK" && input.type === "SPACER_PAGE_BLOCK";
};

export {
    isSpacerPageBlock,
    SpacerPageBlock_Edit,
    spacerPageBlockFactory,
    spacerPageBlockIcon,
    spacerPageBlockType,
    spacerPageBlockZodSchema,
};
export type { SpacerPageBlock };
